import React, { useState, useEffect, Fragment } from 'react'
// ** React Imports
import { Outlet } from "react-router-dom"
import { Clipboard, BarChart, Search } from "react-feather"
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "../@core/layouts/VerticalLayout"
import { isUserLoggedIn } from "../utility/Utils"
import themeConfig from '../configs/themeConfig'
import { useSelector } from "react-redux"
import ComponentSpinner from '../components/spinner/Loading-spinner'
// import store from '../views/redux/store'
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"

const VerticalLayout = (props) => {
  const [menusData, setMenuData] = useState([])
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee
  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  useEffect(() => {
    if (isUserLoggedIn()) {
      if (isEmployee) {
          if (JSON.parse(isUserLoggedIn()).isEmployee) {
            setMenuData([
              {
                id: "home",
                title: "Home",
                icon: '',
                img: themeConfig.navicons.home,
                img1: themeConfig.navicons.home1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/home"
              },
              {
                id: "dashboard",
                title: "Dashboard",
                icon: '',
                img: themeConfig.navicons.dashboard,
                img1: themeConfig.navicons.dashboard1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/dashboard"
              },
              {
                id: "search",
                title: "Work Orders",
                icon: '',
                img: themeConfig.navicons.Search,
                img1: themeConfig.navicons.Search1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/search"
              },
                  // {
            //   id: "library",
            //   title: "Library",
            //   icon: '',
            //   img: themeConfig.navicons.library,
            //   img1: themeConfig.navicons.library1,
            //   color1: '#fff',
            //   color2: '#313131',
            //   navLink: "/library"
            // },
              {
                id: "account",
                title: "Account",
                icon: '',
                img: themeConfig.navicons.Profile,
                img1: themeConfig.navicons.Profile1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/my-profile"
              }
            ])
          }
      } else {
        if (stores?.acSpinner) {
            if (stores?.unauthorize && !isEmployee) {
              setMenuData([]) 
            } 
            if (!stores.unauthorize && !isEmployee) {
              setMenuData([
                {
                  id: "home",
                  title: "Home",
                  icon: '',
                  img: themeConfig.navicons.home,
                  img1: themeConfig.navicons.home1,
                  color1: '#fff',
                  color2: '#313131',
                  navLink: "/home"
                },
                {
                  id: "dashboard",
                  title: "Dashboard",
                  icon: '',
                  img: themeConfig.navicons.dashboard,
                  img1: themeConfig.navicons.dashboard1,
                  color1: '#fff',
                  color2: '#313131',
                  navLink: "/dashboard"
                },
                {
                  id: "search",
                  title: "Work Orders",
                  icon: '',
                  img: themeConfig.navicons.Search,
                  img1: themeConfig.navicons.Search1,
                  color1: '#fff',
                  color2: '#313131',
                  navLink: "/search"
                },
                {
                  id: "account",
                  title: "Account",
                  icon: '',
                  img: themeConfig.navicons.Profile,
                  img1: themeConfig.navicons.Profile1,
                  color1: '#fff',
                  color2: '#313131',
                  navLink: "/my-profile"
                }
              ])
            }
        }
      }
         
    }
  }, [isUserLoggedIn(), stores.unauthorize, stores?.acSpinner])

  return (
    <Layout menuData={menusData} {...props}>
      <Outlet />
    </Layout>  
  )
}

export default VerticalLayout
